module.exports = __webpack_public_path__ + "static/media/alert.69700e91.svg";